<div [ngClass]="filter.inputClass" class="search-filter-fields"
    *ngIf="section.open">
    <input type="search" [hidden]="filter.hide" class="form-control font-relative-width" placeholder="{{filter.placeholder}}" 
        [(ngModel)]="filter.value" (ngModelChange)="inputChangeEmitter.emit()">
</div>